import { ExpiredTokenCode } from '@tradingblock/types';
import Config from '../../config';
import { FeedActions, getFeedActions } from './FeedState';
import _ from 'lodash';
import { NotificationActions, SessionActions } from '../global/actions';

// ExpiringTokensWebSocketService.ts
class ExpiringTokensWebSocketService {
  private static instance: ExpiringTokensWebSocketService;
  private ws: WebSocket | null = null;

  private constructor() {}

  // Singleton instance access
  public static getInstance(): ExpiringTokensWebSocketService {
    if (!ExpiringTokensWebSocketService.instance) {
      ExpiringTokensWebSocketService.instance = new ExpiringTokensWebSocketService();
      console.log('new websocket instance created');
    }
    return ExpiringTokensWebSocketService.instance;
  }

  // Initialize WebSocket connection
  public async connect(dispatch: React.Dispatch<FeedActions>, dispatcher: any, globalDispatch: any, apiToken: string) {
    try {
      if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
        this.ws = new WebSocket(Config.expiringTokensWebsockets + '?token=' + apiToken);

        this.ws.onopen = () => {
          dispatcher.connected();
          getFeedActions(dispatch).setExpiringTokensFeedStatus('open');
          globalDispatch(
            NotificationActions.hide({
              status: 'Error',
              title: 'Expiring Tokens WebSocket Error',
              message: '',
              global: false,
              time: new Date(),
              key: 'expiring-tokens-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
          globalDispatch(
            NotificationActions.read({
              status: 'Error',
              title: 'Expiring Tokens WebSocket Error',
              message: '',
              global: false,
              time: new Date(),
              key: 'expiring-tokens-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
        };

        this.ws.onmessage = (ev: MessageEvent) => {
          const jsonVal = ev.data;
          const valObj: { token: string; reason: string } = JSON.parse(jsonVal);
          if (valObj.token === apiToken) {
            let code: ExpiredTokenCode;
            switch (valObj.reason) {
              case 'DuplicateLogins':
                code = ExpiredTokenCode.DuplicateLogin;
                break;
              case 'ExpiredToken':
                code = ExpiredTokenCode.Expired;
                break;
              default:
                code = ExpiredTokenCode.Unknown;
            }
            console.warn('expired token message', jsonVal, valObj);
            globalDispatch(SessionActions.expired({ code: code }));
          }
        };

        this.ws.onclose = (ev: CloseEvent) => {
          if (ev.reason) {
            getFeedActions(dispatch).setExpiringTokensCloseReason(ev.reason);
            console.warn(ev.reason);
          }
          getFeedActions(dispatch).setExpiringTokensFeedStatus('closed');
          globalDispatch(
            NotificationActions.add({
              status: 'Error',
              title: 'Expiring Tokens WebSocket Error',
              message: ev.reason ? ev.reason : 'Expiring Tokens Websocket error',
              global: false,
              time: new Date(),
              key: 'expiring-tokens-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
        };

        this.ws.onerror = error => {
          dispatcher.errored({ error: error, reason: 'Unable to connect', message: 'Datafeed error' });
          getFeedActions(dispatch).setExpiringTokensFeedStatus('error');
          console.error('Expiring Tokens WebSocket error:', error);
          globalDispatch(
            NotificationActions.add({
              status: 'Error',
              title: 'Expiring Tokens WebSocket Error',
              message: 'Expiring Tokens Websocket error',
              global: false,
              time: new Date(),
              key: 'expiring-tokens-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
        };
      }
    } catch (createWebsocketError) {
      dispatcher.errored({
        error: createWebsocketError,
        reason: 'Error creating expiring tokens websocket',
        message: 'Expiring Tokens Websocket error',
      });
    }
  }
  // Send message to WebSocket
  public sendMessage(data: string | ArrayBufferLike | Blob | ArrayBufferView) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(data);
    } else if (this.ws) {
      console.warn('trying to send message to closed/closing websocket', data);
    }
  }

  public shouldTryReconnect = () => {
    if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
      return true;
    }
    return false;
  };

  // Close WebSocket connection
  public closeConnection() {
    if (this.ws) {
      this.ws.close();
    }
  }
}

export const expiringTokensWebSocketService = ExpiringTokensWebSocketService.getInstance();
